import { Container } from "@mui/material";
import React from "react";
import { FaRegCopyright } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-slate-800 to-slate-700 shadow-inner py-2">
      <Container maxWidth="lg">
        <div className="mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center text-gray-200 text-xs">
          <div className="flex items-center gap-1 uppercase tracking-wide text-center">
            <FaRegCopyright className="text-sm" />
            Tanushree Makeup Artist ({new Date().getFullYear()})
          </div>

          <div className="text-[10px] flex items-center gap-2 uppercase tracking-wide mt-2 md:mt-0 text-center">
            <span>Designed & Developed</span>
            <span>
              by&nbsp;
              <a
                href="tel:+918709278485"
                className="text-primary font-semibold hover:underline bg-white rounded-gray-100 px-1.5 py-1 rounded"
              >
                Jitendra Kumar (8709278485)
              </a>
            </span>
          </div>
        </div>
      </Container>
    </footer>
  );
}
